import Vue from 'vue'
import Vuex from 'vuex'
import VueJwtDecode from "vue-jwt-decode";
import moment from "moment";
import createPersistedState from 'vuex-persistedstate';



Vue.use(Vuex)

// Prototypes existentes
Vue.prototype.$mostrarPreload = function () {
  this.$store.commit("preload", true);
}

Vue.prototype.$removePreload = function () {
  this.$store.commit("preload", false);
}

Vue.prototype.$setLocale = function (local) {
  this.$store.commit("setLocale", local);
}

Vue.prototype.$setAba = function (local) {
  this.$store.commit("setAba", local);
}

Vue.prototype.$setCalcLimpa = function (local) {
  this.$store.commit("setCalcLimpa", local);
}

// Novo prototype para carregar dados do fornecedor
Vue.prototype.$carregarDadosFornecedor = function (id) {
  this.$store.dispatch("carregarDadosFornecedor", id);
}

// Novo prototype para visualizar o cartão CNPJ
Vue.prototype.$visualizarCartaoCNPJ = function (arquivoObj) {
  return this.$store.dispatch("visualizarCartaoCNPJ", arquivoObj);
}

// Verificações de perfil existentes
Vue.prototype.$verificaPerfilCadastrador = function () {
    return (this.$store.getters.getPerfil === "cadastrador")
}

Vue.prototype.$verificaPerfilFornecedor = function () {
    return (this.$store.getters.getPerfil === "fornecedor");
}

Vue.prototype.$getStatusSolicitacao = function () {
  try {
    if (this.$store.getters.getPerfil === "fornecedor") {
      const status = this.$store.getters.getStatusSolicitacao;
      if (status && typeof status.get === 'function') {
        return status; // retorna apenas se for seguro
      }
    }
  } catch (e) {
    console.warn("Erro ao acessar $getStatusSolicitacao:", e);
  }
  return null;
}

Vue.prototype.$getStatusSIMPAS = function () {
  if (this.$store.getters.getPerfil === "fornecedor")
    return this.$store.getters.getStatusSIMPAS;
  else
    return null
}

Vue.prototype.$verificaPerfilHabilitador = function () {
    return (this.$store.getters.getPerfil === "validador" || this.$store.getters.getPerfil === "validadormaster");
}

Vue.prototype.$verificaPerfilHabilitadorMaster = function () {   
    return (this.$store.getters.getPerfil === "validadormaster");
}

Vue.prototype.$VerificaUsuarioProdeb = function () {
  let urlTeste = Vue.prototype.$baseURL;
  if(((urlTeste.match("localhost") || urlTeste.match("https://www.comprasnetadm.ba.gov.br/api/")) && 
  this.$store.getters.getUsuarioId == 1932 ) || 
  ((urlTeste.match("localhost") || urlTeste.match("http://homologa.comprasnetadm.ba.gov.br/api/")) && 
  this.$store.getters.getUsuarioId == 2195 ))
  {  
    return true;
  }
  else{
    return false;
  }
}

Vue.prototype.$verificaPerfilSomenteHabilitador = function () {
  return (this.$store.getters.getPerfil === "validador");
}

export default new Vuex.Store({
  state: {
    token: null,
    tokenRefresh: null,
    horaLogin: null,
    preload: false,
    locale: "pt-br",
    horaUltimoEvento: null,
    horaAtualEvento: null,
    horaFinalSessao: null,
    openMenu: false,
    aba: "tab-dados",
    calcLimpa: 1,
    erro: null,
    fornecedorAtivo: {
      tipFornecedor: null, // ou 'F'
      numCgcFornecedor: ''
    },
    cartaoCNPJ: null // Novo estado para armazenar dados do cartão CNPJ
  },
  
  getters: {
    token: state => state.token,
    tokenRefresh: state => state.tokenRefresh,
    horaLogin: state => state.horaLogin,
    locale: state => state.locale,
    activeAba: state => state.aba,
    horaUltimoEvento: state => state.horaUltimoEvento,
    horaAtualEvento: state => state.horaAtualEvento,
    horaFinalSessao: state => state.horaFinalSessao,
    openMenu: state => state.openMenu,
    AbaAtivaCalc: state => state.aba,
    CalcLimpa: state => state.calcLimpa,
    cartaoCNPJ: state => state.cartaoCNPJ,
    
  
    // Getter para fornecedorAtivo
    fornecedorAtivo: state => state.fornecedorAtivo,
    
    getPerfil: state => {
      let tokenObj = {};
      if (state.token) {
        tokenObj = VueJwtDecode.decode(state.token);
        return (tokenObj.Perfil) ? (tokenObj.Perfil).toLocaleLowerCase() : null;
      }
      else{
        return null
      }
    },

    
    getStatusSolicitacao: state => {

      let tokenObj = {};
      if (state && state.token) {
        tokenObj = VueJwtDecode.decode(state.token);
        let fornecedor = tokenObj.fornecedor ? JSON.parse(tokenObj.fornecedor): {};
        return fornecedor ? fornecedor.SituacaoSolicitacao : null;
      }
      return null;
    },

    getStatusSIMPAS: state => {
      let tokenObj = {};
      if (state && state.token) {
        tokenObj = VueJwtDecode.decode(state.token);
        let fornecedor = tokenObj.fornecedor ? JSON.parse(tokenObj.fornecedor): {};
        return fornecedor && (fornecedor.situacaoSIMPAS !== "10" || fornecedor.cidade) ? fornecedor.situacaoSIMPAS : null;
      }
      return null;
    },

    getUsuarioId: state => {
      let tokenObj = {};
      if (state.token) {
        tokenObj = VueJwtDecode.decode(state.token);
        return (tokenObj.UsuarioId) ? (tokenObj.UsuarioId).toLocaleLowerCase() : null;
      }
      else{
        return null;
      }
    },

    getLoginUsuario: state => {
      if (state.token) {
        const tokenObj = VueJwtDecode.decode(state.token);
        // Extrai o login do formato "login/nome" (ex: "13DIRES02/Monica Veloso")
        return tokenObj.name ? tokenObj.name.split('/')[0] : null;
      }
      return null;
    }
  },
  
  actions: {
    mostrarPreload(dispatch) {
      dispatch.commit('preload', true)
    },
    removePreload(dispatch) {
      dispatch.commit('preload', false)
    },
    setLocale(dispatch, local) {
      dispatch.commit('setLocale', local)
    },
    setAba(dispatch, local) {
      dispatch.commit('setAba', local)
    },
    setCalcLimpa(dispatch, local) {
      dispatch.commit('setCalcLimpa', local)
    },
    
    carregarDadosFornecedor({ commit, state }) {
      if (state.token) {
        const tokenObj = VueJwtDecode.decode(state.token);
    
        if (tokenObj && tokenObj.fornecedor) {
          const fornecedor = JSON.parse(tokenObj.fornecedor);
    
          commit('setFornecedorAtivo', fornecedor);
        }
      }
    },
      
  
    // Nova action para visualizar o cartão CNPJ
    async visualizarCartaoCNPJ({ commit }, { numCgcFornecedor, arquivo }) {
      try {
        commit('mostrarPreload');
        
        // 3. Acesse a instância via Vue.prototype
        const response = await Vue.prototype.$axios.post('arquivo/file', {
          file: arquivo,
          numCgcFornecedor: numCgcFornecedor.replace(/\D/g, '')
        }, {
          responseType: 'blob'
        });
  
        // 3. Criar e abrir Blob
        const blob = new Blob([response.data], { 
          type: response.headers['content-type'] || 'application/pdf' 
        });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
  
        // 4. Gerenciar memória
        setTimeout(() => URL.revokeObjectURL(url), 60000);
  
      } catch (error) {
        console.error('Erro:', error);
        commit('setErro', 'Falha ao abrir Cartão CNPJ');
      } finally {
        commit('removePreload');
      }
    }
  },
  
  plugins: [
    // Plugin utilizado para persistir o state da store no localstorage
    function () {
      let vuex = window.localStorage.vuex;
      if (vuex) {
        vuex = JSON.parse(window.localStorage.vuex)
        vuex.preload = false
        localStorage.setItem('vuex', JSON.stringify(vuex))
      }
    },
    createPersistedState()
  ],
  
  mutations: {
    setToken(store, value) {
      store.token = value;
      let tokenObj = null;
      let dateZero = new Date(0);

      if (store.token) {
        tokenObj = VueJwtDecode.decode(store.token);
        if (tokenObj.nbf) {
          dateZero.setSeconds(tokenObj.nbf);
        }
        store.horaLogin = moment(dateZero).format("YYYY-MM-DD HH:mm:ss");
        let dateZero2 = new Date(0);
        dateZero2.setSeconds(tokenObj.exp);
        store.horaFinalSessao = moment(dateZero2).format("YYYY-MM-DD HH:mm:ss");
      } else {
        store.horaLogin = null;
      }
    },

    setTokenRefresh(store, value) {
      store.tokenRefresh = value;
    },

    preload(store, value) {
      store.preload = value
    },
    
    setLocale(store, value) {
      store.locale = value
    },
    
    setAba(store, value) {      
      store.aba = value.abaAtiva ? value.abaAtiva : value;
    },
    
    setCalcLimpa(store, value) {      
      store.calcLimpa = value;
    },
    
    setHoraEvento(store) {
      store.horaUltimoEvento = store.horaAtualEvento
      store.horaAtualEvento = moment().format("YYYY-MM-DD HH:mm:ss");
    },

    setOpenMenu(store, value) {
      store.openMenu = value
    },
  
    // Mutation para atualizar dados do fornecedor
    setFornecedorAtivo(state, fornecedor) {    
     
      state.fornecedorAtivo = {
        tipFornecedor: fornecedor.tipoFornecedor, // Mapeia 'tipoFornecedor' para 'tipFornecedor'
        ...fornecedor
      };
    },
    // Nova mutation para definir os dados do cartão CNPJ
    setCartaoCNPJ(state, data) {
      state.cartaoCNPJ = data;
    },
    mostrarPreload(state) {
      state.preload = true;
    },
    removePreload(state) {
      state.preload = false;
    },
    setErro(state, mensagem) {
      state.erro = mensagem;
    }
  },
});
